import {
    GET_LIST_DOCTOR_APPOINTMENTS
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    list: {
        data: [],
        pagination: {
            currentPage: 1,
            total: 0, // total records
            perPage: 50
        },
    },
    statistics: {}
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_LIST_DOCTOR_APPOINTMENTS: {
            return {
                ...state,
                list: {
                    data: action.payload?.list.data || [],
                    pagination: {
                        currentPage: parseInt(action.payload.list?.current_page),
                        total: parseInt(action.payload.list?.total),
                        perPage: parseInt(action.payload?.list.per_page),
                    }
                },
                statistics: action.payload?.statistics || {}
            }
        }
        default: return { ...state };
    }
}
